import React, { useState, useEffect } from "react";
import './login.css'
import { Input, Password } from './usefulcomps/HexInput/InputBox'
import Button from './HexButton/button'
import Swal from "sweetalert2";
import Hexapi from './usefulcomps/HexAPI/Hexapi'
import Support from './Support'

sessionStorage.setItem("Apipathurl", "https://hexbss.xyz/AudioComplaintLogger/");


export default function Login() {
  // React States
  // const [errorMessages, setErrorMessages] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  // const [isforget, setIsforget] = useState(false);
  // const [isOpenSupport, setisOpenSupport] = useState(false);
  const [userlabelcolor, setuserlabelcolor] = useState("black")
  const [passlabelcolor, setpasslabelcolor] = useState("black")
  const [username, setusername] = useState("")
  const [password, setpassword] = useState("")


  // const [globalcolor, setglobalcolor] = useState([])

  // const handleforget = (event) => {
  //   console.log(event)
  //   setisOpenSupport(true)
  // }

  const setSessions = (str) => {
    console.log(str)
    while (str.toLowerCase().includes('sessionstorage.setitem')) {

      let key = str.substring(str.indexOf('("') + 2, str.indexOf('",'))
      let value = str.substring(str.indexOf(',') + 2, str.indexOf('")'))
      sessionStorage.setItem(key, value);
      str = str.replace(`sessionStorage.setItem("${key}","${value}");`, '')
    }
  }

  const handleSubmit = (event) => {
    //Prevent page reload
    // var { username, password } = document.forms[0];
    event.preventDefault();
    console.log(username)
    console.log(password)


    let obj = {
      url: `SuccessfullyV2.php`,
      username: `${username}`,
      password: `${password}`,
    }
    Hexapi(obj).then(resp => {
      console.log(resp)
      // console.log(resp[0])
      if (resp[''][0]['command'] == 0) {
        Swal.fire({
          html: `${resp[""][0]["msg"]}`,
          confirmButtonColor: '#F57600'
        })
      }
      else {
        console.log(resp)
        let str = resp[0]
        str = str.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(' ', '')
        console.log(str)
        setSessions(str)
        window.location.href = `${sessionStorage.getItem("url")}dashboard`
      }
 
    })
  };

  // JSX code for login form
  const renderForm = (
    <div className="form">
      <form onSubmit={handleSubmit}>
        <div className="input-container">

          <Input
            labelStyle={{ fontWeight: "600", color: `${userlabelcolor}` }}
            label="Username"
            type="text"
            className="form-control"
            name="username"
            value={username}
            inline={false}
            onChange={(event) => setusername(event.target.value)}
          />

        </div>
        <div className="input-container">
          <Input
            labelStyle={{ fontWeight: "600", color: `${passlabelcolor}` }}
            label="Password"
            type="password"
            className="form-control"
            name="password"
            value={password}
            onChange={(event) => setpassword(event.target.value)}
            inline={false}
          />

        </div>

        <div className="button-container">

          <Button buttonTitle="Submit" />
          {/* <span onClick={handleforget} style={{ cursor: "pointer", width: "150px", margin: "15px", borderRadius: "10px", fontSize: "15px", fontWeight: "semi-bold", fontfamily: "system-ui" }}>Forget Password!!</span> */}
        </div>
      </form>
    </div>
  );

  return (
    <>
      <div className="app" >
        <div>
          {/* <span>Lawcrux</span> */}
          <span style={{ width: "150px", margin: "15px", borderRadius: "10px", fontSize: "30px", fontWeight: "bold", fontfamily: "system-ui" }}>Audio Complaint Logger</span>
          {/* <img style={{ width: "150px", margin: "15px", borderRadius: "10px" }} src={process.env.PUBLIC_URL + "VMS.png"} /> */}
        </div>
        <div className="appflex">
          <div className="login-form" >
            <div className="title">LOGIN</div>
            {isSubmitted ? <div>You can achive your goal</div> : renderForm}
          </div>


          {/* <div style={{ display: "flex", flexDirection: "column", margin: "30px" }}>
            <span style={{ fontWeight: "100" }}>Designed and Powered by</span>
            <img style={{ width: "150px", margin: "0px 0px 0px 20px" }} src={process.env.PUBLIC_URL + "HEX Logo.png"} />

          </div> */}

          {/* {
              isOpenSupport &&
              <Support
                openModal={isOpenSupport}
                closeModal={() => setisOpenSupport(false)}
                user={username}
              />
            } */}
        </div>
      </div>
    </>
  )
};